

import React from 'react';
import HeroSection from '../components/Home/HeroSection';
import Features from '../components/Home/Features';
import Stats from '../components/Home/Stats';

const Home = () => {
  return (
    <>
      <HeroSection />
      <Features />
      <Stats />
    </>
  );
};

export default Home;
